import React, { useCallback, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { getPrices } from '../../../utils/rental-items/prepareReceivedRentalItemsData';
import moment from 'moment';
import { WIDGET_RENTAL_ITEMS } from '../../../graphql/queries/rental-items';

export const useRentalItemsInfiniteQuery = ({ startDate, endDate, units, ownerId }, skip) => {
  const [page, setPage] = useState(0);
  const [rentalItems, setRentalItems] = useState(null);
  const [fetchMore, { loading, data }] = useLazyQuery(WIDGET_RENTAL_ITEMS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (rentalData) => {
      if (!rentalData || !rentalData.rentalItems) return;

      const newRentalItems = rentalData.rentalItems
        .filter(item => item?.status?.id === 1)
        .map(item => ({
          ...item,
          unitsNumber: item.availableUnits,
          ...getPrices(item)
        }));
      if (newRentalItems.length > 0) {
        setPage(page + 1);
      }

      setRentalItems([...(rentalItems || []), ...newRentalItems]);
    }
  });

  const fetchData = useCallback((requestedPage) => {
    const variables = {
      page: requestedPage ?? 0,
      businessOwnerId: ownerId,
      numberOfRentalItemsPerPage: 15,
      startPeriod: startDate && moment(startDate).format('YYYY-MM-DD'),
      endPeriod: endDate && moment(endDate).format('YYYY-MM-DD')
    };

    if (units) {
      variables.unitsNumber = units;
    }

    fetchMore({ variables });
  }, [units, ownerId, startDate, endDate]);

  useEffect(() => {
    if (!skip) {
      fetchData(0);
    }
  }, []);

  useEffect(() => {
    if (!startDate || !endDate) return;
    setRentalItems([]);
    fetchData(0);
    setPage(0);
  }, [startDate, endDate]);

  useEffect(() => {
    if (units && startDate && endDate) {
      setRentalItems([]);
      fetchData(0);
      setPage(0);
    }
  }, [units]);

  return {
    rentalItemsPage: page,
    rentalItems,
    fetchRentalItemsData: fetchData,
    loading,
    perPage: data ? data.numberOfRentalItemsPages - 1 : 0
  }
}
